import { useTheme } from '@/context/ThemeContext';

export default function CtaSection() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className={`relative py-28 md:py-36 overflow-hidden transition-colors duration-500 ${isDark ? 'bg-black' : 'bg-[#F5F5F7]'}`}>
      <div className={`absolute top-0 left-0 w-full h-px ${isDark ? 'bg-gradient-to-r from-transparent via-[#38D6D6]/20 to-transparent' : 'bg-gradient-to-r from-transparent via-[#38D6D6]/30 to-transparent'}`} />

      {/* Full-bleed background image */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <img
          src="https://public.readdy.ai/ai/img_res/83576dfed6a05ca75bd2ab6b3648bec5.jpg"
          alt=""
          className={`w-full h-full object-cover object-center transition-opacity duration-500 ${isDark ? 'opacity-[0.12]' : 'opacity-[0.06]'}`}
        />
        <div className={`absolute inset-0 ${isDark ? 'bg-gradient-to-b from-black/50 via-transparent to-black/50' : 'bg-gradient-to-b from-[#F5F5F7]/70 via-transparent to-[#F5F5F7]/70'}`}></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10">
        <div className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full border mb-10 ${isDark ? 'border-[#38D6D6]/25 bg-[#38D6D6]/5' : 'border-[#38D6D6]/30 bg-[#38D6D6]/8'}`}>
          <span className="w-1.5 h-1.5 rounded-full bg-[#38D6D6] animate-pulse flex-shrink-0"></span>
          <span className="text-xs font-grotesk text-[#38D6D6] tracking-widest uppercase">Ready to Deploy</span>
        </div>

        <h2 className={`font-sora font-800 text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-7 ${isDark ? 'text-white' : 'text-[#1D1D1F]'}`}>
          Stop Losing Revenue to<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#38D6D6] to-[#4FA3FF]">
            Missed Opportunities
          </span>
        </h2>

        <p className={`font-grotesk text-lg max-w-xl mx-auto leading-relaxed mb-12 ${isDark ? 'text-white/55' : 'text-[#1D1D1F]/55'}`}>
          Install a system that works 24/7 to capture and convert every lead.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => scrollTo('contact')}
            className="px-10 py-4 rounded-full font-grotesk font-600 text-base bg-gradient-to-r from-[#38D6D6] to-[#4FA3FF] text-black hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
          >
            Book Your Demo
          </button>
          <button
            onClick={() => scrollTo('process')}
            className={`px-10 py-4 rounded-full font-grotesk font-600 text-base border transition-all cursor-pointer whitespace-nowrap ${
              isDark ? 'border-white/20 text-white hover:bg-white/8' : 'border-black/20 text-[#1D1D1F] hover:bg-black/5'
            }`}
          >
            See the Process
          </button>
        </div>
      </div>

      <div className={`absolute bottom-0 left-0 w-full h-px ${isDark ? 'bg-gradient-to-r from-transparent via-white/5 to-transparent' : 'bg-gradient-to-r from-transparent via-black/5 to-transparent'}`} />
    </section>
  );
}
